import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const routeCollectorService = {};

// List Route
routeCollectorService.listRouteCollector = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "name",
    "code",
    "note",
    // "phone_number",
    // "address",
    // "ward_code",
    // "district_code",
    // "province_code",
    "description",
    "maker_id",
    "maker_date",
    "maker.id",
    "maker.display_name",
    "checker_id",
    "checker_date",
    "checker.id",
    "checker.display_name",
    "record_status",
    "tenant_code",
  ];

  return fetchV2({
    url: `${env.API_MSP}/collector/routes`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create Route
routeCollectorService.createRouteCollector = data => {
  return fetchV2({
    url: `${env.API_MSP}/collector/routes`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Route
routeCollectorService.detailRouteCollector = ({
  routeId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/routes/${routeId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update Route
routeCollectorService.updateRouteCollector = ({
  routeId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/routes/${routeId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete Route
routeCollectorService.deleteRouteCollector = ({ routeId = undefined }) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/routes/${routeId}`,
    method: "delete",
  });
};

// Active Route
routeCollectorService.activeRouteCollector = ({
  routeId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/collector/routes/${routeId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default routeCollectorService;
